import { TransactionCurrency } from '@contracts/payment/Currency';
import type { PermitInstructionAttributes } from '@contracts/permit/PermitInstructionAttributes';

export enum Country {
  CANADA = 'CANADA',
  USA = 'USA',
  OTHER = 'OTHER',
}

export class PermitInstruction {
  readonly jurisdiction: string;
  readonly permitName: string;
  readonly permitType: string;
  readonly country: Country;
  readonly text: string;

  constructor(attributes: PermitInstructionAttributes) {
    this.jurisdiction = attributes.jurisdiction;
    this.permitName = attributes.permit.name;
    this.permitType = attributes.permit.type;
    this.text = attributes.text;

    switch (attributes.permit.currency) {
      case TransactionCurrency.CAD:
        this.country = Country.CANADA;
        break;
      case TransactionCurrency.USD:
        this.country = Country.USA;
        break;
      default:
        this.country = Country.OTHER;
        break;
    }
  }
}
